module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/line-poi-1dd3ce8f314d00e9e4331447bb1f2452.svg";